/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'refund': {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data: '<path pid="0" d="M4.674 18.91l-.887-.88-.887.88.887.878.887-.879zM10.946 4c-.692 0-1.254.556-1.254 1.242 0 .687.562 1.243 1.254 1.243V4zm-.887 7.819L3.787 18.03l1.774 1.757 6.272-6.212-1.774-1.758zm-6.272 7.969L10.059 26l1.774-1.757-6.272-6.212-1.774 1.757zm.887.364h13.172v-2.485H4.674v2.485zM17.846 4h-6.9v2.485h6.9V4zM26 12.076C26 7.616 22.35 4 17.846 4v2.485c3.118 0 5.645 2.503 5.645 5.59H26zm-8.154 8.076c4.503 0 8.154-3.616 8.154-8.076h-2.509c0 3.088-2.527 5.59-5.645 5.59v2.486z" _fill="#fff"/>'
  }
})
